// AboutUs.js
import React from 'react';
import '.././styles.css'

const AboutUs = () => {
  return (
    <div className="legal-links">
      <h1>About Us</h1>
      <p>Welcome to GETFITFAST, your ultimate destination for health and wellness information! We are passionate about helping individuals achieve their health goals and live their best lives.</p>
      
      <h2>Our Mission</h2>
      <p>At GETFITFAST, our mission is to provide accessible, trustworthy, and comprehensive resources related to nutrition, fitness, and overall well-being. We believe that knowledge is power, and we aim to empower our users with the information they need to make informed health choices.</p>

      <h2>What We Offer</h2>
      <p>GETFITFAST offers a wide range of tools and resources, including:</p>
      <ul>
        <li><strong>Calculators:</strong> From BMI and caloric needs to protein intake and age reduction calculators, we have tools to help you understand your health metrics.</li>
        <li><strong>Informative Articles:</strong> Our blog features articles on health and wellness topics, including nutrition tips, fitness advice, and mental well-being strategies.</li>
      </ul>

      <h2>Our Values</h2>
      <p>We are committed to:</p>
      <ul>
        <li><strong>Integrity:</strong> Providing accurate and reliable information to our users.</li>
        <li><strong>Inclusivity:</strong> Welcoming individuals from all walks of life and supporting diverse health journeys.</li>
        <li><strong>Empowerment:</strong> Encouraging users to take charge of their health and wellness.</li>
      </ul>

      <h2>Contact Us</h2>
      <p>If you have any questions, suggestions, or feedback, feel free to reach out to us at <a href="mailto:getfitfast1901@gmail.com">getfitfast1901@gmail.com</a>. We would love to hear from you!</p>

      <h2>Join Us on Our Journey</h2>
      <p>We invite you to explore our website, utilize our resources, and become part of the GETFITFAST community. Together, let’s take the steps toward a healthier and happier life!</p>

      <h2>Disclaimer</h2>
      <p>While we strive to provide accurate and up-to-date information, please consult with a healthcare professional before making any significant changes to your health or wellness routine.</p>
    </div>
  );
};

export default AboutUs;
